// A tiny global loading store with subscription for showing a page-level loading overlay
// It tracks the number of in-flight requests and notifies subscribers on change.

export type LoadingListener = (count: number) => void;

class LoadingStore {
  private count = 0;
  private listeners = new Set<LoadingListener>();

  getCount() {
    return this.count;
  }

  private notify() {
    this.listeners.forEach((l) => l(this.count));
  }

  subscribe(listener: LoadingListener) {
    this.listeners.add(listener);
    // immediate invoke with current
    listener(this.count);
    return () => {
      this.listeners.delete(listener);
    };
  }

  increment() {
    this.count += 1;
    this.notify();
  }

  decrement() {
    // guard against going negative
    if (this.count > 0) this.count -= 1;
    this.notify();
  }

  reset() {
    this.count = 0;
    this.notify();
  }
}

export const loadingStore = new LoadingStore();
